<script setup lang="ts">
import logo from '@/assets/brand/avoschool-logo.svg'
import CookieNotice from '@/components/CookieNotice.vue'

const navItems = [
  { title: 'О школе', to: { path: '/', hash: '#school' } },
  { title: 'Курсы', to: { path: '/', hash: '#courses' } },
  { title: 'Цены', to: { path: '/', hash: '#prices' } },
  { title: 'Отзывы', to: { path: '/', hash: '#reviews' } },
  { title: 'Блог', to: { path: '/blog' } },
  { title: 'Контакты', to: { path: '/', hash: '#contacts' } },
]

const documents = [
  { title: 'Политика конфиденциальности', to: { name: 'policy' } },
  { title: 'Образовательная лицензия', to: { name: 'licence' } },
  { title: 'Публичная оферта', to: { name: 'oferta' } },
  { title: 'Сведения об организации', to: { name: 'sveden' } },
]
</script>

<template>
  <VApp>
    <header class="topbar">
      <RouterLink class="brand" :to="{ path: '/', hash: '#top' }" aria-label="AvoSchool">
        <img :src="logo" alt="AvoSchool">
      </RouterLink>

      <nav class="nav" aria-label="Основная навигация">
        <RouterLink v-for="item in navItems" :key="item.title" :to="item.to">
          {{ item.title }}
        </RouterLink>
      </nav>

      <VBtn
        class="topbar__cta"
        :to="{ path: '/', hash: '#consultation' }"
        prepend-icon="mdi-message-text-outline"
      >
        Консультация
      </VBtn>
    </header>

    <RouterView />

    <footer id="contacts" class="footer">
      <div>
        <img :src="logo" alt="AvoSchool">
        <p>Индивидуальные онлайн-занятия с репетитором для 1-11 классов.</p>
        <div class="footer__social">
          <a
            class="social-link"
            href="https://api.whatsapp.com/send?phone=79930900116"
            target="_blank"
            rel="noopener"
          >
            <img src="/assets/old-site/footer/whatsapp.png" alt="">
            WhatsApp
          </a>
          <a
            class="social-link"
            href="https://vk.com/avoschool"
            target="_blank"
            rel="noopener"
          >
            <img src="/assets/old-site/footer/vk.png" alt="">
            VK
          </a>
        </div>
      </div>

      <address>
        <strong>ИП Минкова Гузель Рамилевна</strong>
        <span>ОГРНИП 321169000068725</span>
        <span>ИНН 165058007821</span>
        <span>420049, Россия, РТ, г. Казань, ул. Спартаковская, д. 88Б</span>
        <a href="mailto:info@avoschool.ru">info@avoschool.ru</a>
      </address>

      <div class="footer__links">
        <RouterLink v-for="item in navItems" :key="item.title" :to="item.to">
          {{ item.title }}
        </RouterLink>
      </div>

      <div class="footer__links">
        <RouterLink v-for="doc in documents" :key="doc.title" :to="doc.to">
          {{ doc.title }}
        </RouterLink>
      </div>

      <p class="footer__copyright">© AvoSchool, 2024-2026. Все права защищены.</p>
    </footer>

    <CookieNotice />
  </VApp>
</template>
